import React, {Suspense} from 'react';
import extract from '../../utils/extractUrlParams';
import {Preloader} from '@ab/components';

const Main = React.lazy(() => import(/* webpackChunkName: "History" */ './views/main.c'));

const History = props => {
    const {match = {}} = props;

    return (
        <Suspense fallback={<Preloader className="center" />}>
            <Main {...props} params={extract(match.params && match.params.json)} />
        </Suspense>
    );
};

export default History;
